// framework/client/helpers/MessagingClient/ConversationListItem.js
import { ComponentBase } from "../../../core/ComponentBase.js";
import { createAvatarElement } from "../avatarHelper.js";

export class ConversationListItem extends ComponentBase {
    static styles = `
        .conversation-list-item {
            display: flex;
            align-items: center;
            padding: 0.75rem 1rem; /* Slightly more padding */
            cursor: pointer;
            border-bottom: 1px solid var(--bs-border-color-translucent);
            transition: background-color 0.15s ease-in-out;
            position: relative;
        }

        .conv-type-icon { /* NEW */
            font-size: 0.9em;
            margin-right: 0.4em;
            opacity: 0.7;
        }
        .conv-name-wrapper { /* NEW wrapper for name and potential processing indicator */
            display: flex;
            align-items: center;
            flex-grow: 1; /* Allow it to take space */
            overflow: hidden; /* Prevent overflow */
        }

        .conversation-list-item:hover {
            background-color: var(--bs-tertiary-bg);
        }
        .conversation-list-item.active {
            background-color: var(--bs-primary-bg-subtle);
            border-left: 3px solid var(--bs-primary); /* Active indicator */
            padding-left: calc(1rem - 3px);
        }
        .conv-details {
            flex-grow: 1;
            overflow: hidden; /* For text truncation */
        }
        .conv-name-time {
            display: flex;
            justify-content: space-between;
            align-items: baseline;
        }
        .conv-name {
            font-weight: 500; /* Slightly bolder name */
            color: var(--bs-emphasis-color);
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            flex-shrink: 1;
        }
        .conv-last-message-time {
            font-size: 0.75rem;
            color: var(--bs-secondary-color);
            white-space: nowrap;
            margin-left: 0.5rem; /* Space between name and time */
        }
        .conv-last-message-snippet {
            font-size: 0.85rem;
            color: var(--bs-secondary-color);
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            display: flex; /* For unread count alignment */
            align-items: center;
        }
        .conv-unread-badge {
            background-color: var(--bs-primary);
            color: white;
            border-radius: 50%;
            font-size: 0.7rem;
            padding: 0.1rem 0.4rem;
            margin-left: auto; /* Push to the right */
            min-width: 18px;
            text-align: center;
        }
                .agent-processing-indicator { /* NEW */
            font-size: 0.8em;
            margin-left: 0.5em;
            color: var(--bs-primary); /* Or a subtle gray */
            display: none; /* Hidden by default */
        }
        .agent-processing-indicator.processing { /* NEW */
            display: inline-block;
        }
        .agent-processing-indicator .spinner-border-sm { /* NEW */
            width: 0.8rem;
            height: 0.8rem;
            border-width: 0.15em;
        }

    `;

    constructor(config) { // Expects { appClient, conversationData, instanceId }
        super(config);
        this.conversationData = this.config.conversationData;
        this.typingDisplayNames = this.config.typingDisplayNames || [];
        this.isAgentProcessing = false;
        this.boundHandleAgentProcessingStatus = this.handleAgentProcessingStatus.bind(this);
        this.applyStyles();
    }

    async initialize() {
        if (this.conversationData.channelType === 'group' || this.conversationData.otherParticipantType === 'agent') {
            this.appClient.events.server.on('agent_processing_status', this.boundHandleAgentProcessingStatus);
        }

        await super.initialize();
    }

  handleAgentProcessingStatus(eventData) {
        // eventData: { agentContactId, agentName, channelId, status }

        this.log.debug(`ConversationListItem (${this.conversationData.channelId}) received agent_processing_status:`, eventData);

        let relevantToThisItem = false;

        if (eventData.channelId === this.conversationData.channelId) {
            // This condition now works for BOTH group chats (where eventData.channelId is the group's channelId)
            // AND for DMs (where eventData.channelId was set to the DM's conversationId/channelId by the server).

            if (this.conversationData.channelType === 'group') {
                // For a group, the event is relevant if the processing agent is part of this group.
                // We might not have full member list here, so we assume if channelId matches, it's relevant.
                // A stricter check would be if this.conversationData.members includes eventData.agentContactId.
                relevantToThisItem = true;
                this.log.debug(`Processing status for group ${this.conversationData.displayName} from agent ${eventData.agentName}`);
            } else if (this.conversationData.channelType === 'direct_message') {
                // For a DM, the event is relevant if the processing agent IS the other participant in this DM.
                if (this.conversationData.otherParticipantType === 'agent' &&
                    this.conversationData.otherParticipantContactId === eventData.agentContactId) {
                    relevantToThisItem = true;
                    this.log.debug(`Processing status for DM with agent ${this.conversationData.displayName} (they are processing)`);
                }
            }
        }


        if (relevantToThisItem) {
            const newProcessingState = (eventData.status === 'processing_request' || eventData.status === 'tool_execution');
            if (this.isAgentProcessing !== newProcessingState) {
                this.isAgentProcessing = newProcessingState;
                this.log.debug(`Updating processing state for ${this.conversationData.channelId} to ${this.isAgentProcessing}`);
                if (this.container) {
                    this.render();
                }
            }
        } else {
            // If the event is not for this item, but this item *was* showing processing for this agent, turn it off.
            // This can happen if the agent finishes processing for *another* conversation.
            // However, the 'idle' event should be specific to the channelId.
            // This 'else' branch might not be strictly necessary if 'idle' events are correctly targeted.
            if (this.isAgentProcessing && eventData.agentContactId === this.conversationData.otherParticipantContactId && eventData.status === 'idle') {
                 // this.log.debug(`Agent ${eventData.agentName} went idle elsewhere, ensuring indicator is off for DM ${this.conversationData.channelId}`);
                 // this.isAgentProcessing = false;
                 // if (this.container) this.render();
                 // This part is tricky and might lead to premature indicator removal.
                 // Relying on the channelId match is safer.
            }
        }
    }


    render() {
        if (!this.container) {
            this.container = document.createElement('div');
            this.container.className = 'conversation-list-item';
            this.container.setAttribute('data-channel-id', this.conversationData.channelId);
            this.container.addEventListener('click', () => {
                this.emit('conversationSelected', { conversationId: this.conversationData.channelId });
            });
        }

        if (this.config.isActive) {
            this.container.classList.add('active');
        } else {
            this.container.classList.remove('active');
        }

        const avatarElement = createAvatarElement({
            displayName: this.conversationData.displayName,
            avatarUrl: this.conversationData.displayAvatar,
            sizeClass: 'default',
            additionalClasses: ['me-2']
        });

        const lastMessageTime = this.conversationData.lastMessageTimestamp
            ? new Date(this.conversationData.lastMessageTimestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
            : '';

        // --- CONTACT TYPE ICON ---
        let typeIconHtml = '';
        if (this.conversationData.channelType === 'group') {
            typeIconHtml = `<i class="bi bi-people-fill conv-type-icon text-secondary"></i>`;
        } else if (this.conversationData.channelType === 'direct_message') {
            switch (this.conversationData.otherParticipantType) {
                case 'agent':
                    typeIconHtml = `<i class="bi bi-robot conv-type-icon text-info"></i>`;
                    break;
                case 'internal_user':
                    typeIconHtml = `<i class="bi bi-person-fill conv-type-icon text-success"></i>`;
                    break;
                case 'external_contact':
                    typeIconHtml = `<i class="bi bi-person-badge conv-type-icon text-warning"></i>`;
                    break;
            }
        }
        // --- END CONTACT TYPE ICON ---

        // --- AGENT PROCESSING INDICATOR ---
        let agentProcessingIndicatorHtml = '';
        if (this.isAgentProcessing) {
            agentProcessingIndicatorHtml = `
                <span class="agent-processing-indicator processing" title="${this.t('Agent is working...')}">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                </span>
            `;
        }
        // --- END AGENT PROCESSING INDICATOR ---


        let snippetOrTypingIndicatorHtml = '';
        const snippetElement = document.createElement('span');

        if (this.typingDisplayNames && this.typingDisplayNames.length > 0) {
            // ... (existing typing indicator logic) ...
            let typingText;
            if (this.typingDisplayNames.length === 1) {
                typingText = this.t("{{name}} is typing...", { name: this.typingDisplayNames[0] });
            } else if (this.typingDisplayNames.length === 2) {
                typingText = this.t("{{name1}} and {{name2}} are typing...", { name1: this.typingDisplayNames[0], name2: this.typingDisplayNames[1] });
            } else {
                typingText = this.t("Multiple people are typing...");
            }
            snippetElement.textContent = typingText;
            snippetElement.classList.add('typing-indicator');
        } else {
            snippetElement.textContent = this.conversationData.lastMessageSnippet || this.t('No messages yet...');
        }
        snippetOrTypingIndicatorHtml = snippetElement.outerHTML;

        const unreadCount = this.conversationData.unreadCount || 0;

        this.container.innerHTML = `
            ${avatarElement.outerHTML}
            <div class="conv-details">
                <div class="conv-name-time">
                    <div class="conv-name-wrapper"> <!-- NEW WRAPPER -->
                        ${typeIconHtml} <!-- TYPE ICON HERE -->
                        <span class="conv-name">${this.conversationData.displayName || 'Unknown Conversation'}</span>
                        ${agentProcessingIndicatorHtml} <!-- PROCESSING INDICATOR HERE -->
                    </div>
                    <span class="conv-last-message-time">${lastMessageTime}</span>
                </div>
                <div class="conv-last-message-snippet">
                    ${snippetOrTypingIndicatorHtml}
                    ${unreadCount > 0 ? `<span class="conv-unread-badge">${unreadCount > 9 ? '9+' : unreadCount}</span>` : ''}
                </div>
            </div>
        `;

        this.appClient.tx.applyTranslations(this.container);
        return this.container;
    }


    updateData(newData, isActive, typingDisplayNames = []) { // Add typingDisplayNames parameter
        this.conversationData = newData;
        this.config.isActive = isActive;
        this.typingDisplayNames = typingDisplayNames;
        if (this.container) {
            this.render();
        }
    }


    destroy() {
        this.appClient.events.server.off('agent_processing_status', this.boundHandleAgentProcessingStatus);
        this.container?.removeEventListener('click', () => { });
        super.destroy();
    }
}